import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class ItemHdrQueryCriteriaClass extends BaseCriteriaModel {
  code?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  txn_type?: Optional<string> = Optional.empty();
  guids?: Optional<string> = Optional.empty(); /** @param guids is comma separated E.g: 4BC80017-22CC-4A29-9511-E22C4EB97AD5,4BC80017-22CC-4A29-9511-E22C4EB97AD5*/

  param_code?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
}

export class ItemHdrCriteriaModelQuery {
  query = '';

  constructor( ItemHdrCriteriaModel: ItemHdrQueryCriteriaClass) {
    if (!ItemHdrCriteriaModel) {
      return;
    }

    this.query += ItemHdrCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += ItemHdrCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += ItemHdrCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += ItemHdrCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += ItemHdrCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += ItemHdrCriteriaModel.guids.filter(x => x !== '').map(x => '&guids=' + x).orElse('');

    //this.query += '&status=' + ItemHdrCriteriaModel.status;
    //this.query += '&orderBy=' + ItemHdrCriteriaModel.orderBy;
    //this.query += '&order=' + ItemHdrCriteriaModel.order;
    //this.query += '&offset=' + ItemHdrCriteriaModel.offset + '&limit=' + ItemHdrCriteriaModel.limit;
  }


}
